import { NgModule, Type } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {
  CovalentDataTableModule, CovalentMediaModule, CovalentLoadingModule,
  CovalentNotificationsModule, CovalentLayoutModule, CovalentMenuModule,
  CovalentPagingModule, CovalentSearchModule,
  CovalentCommonModule, CovalentDialogsModule, CovalentStepsModule,
  CovalentChipsModule, CovalentExpansionPanelModule,
} from '@covalent/core';
import {
  MdButtonModule, MdCardModule, MdIconModule,
  MdListModule, MdMenuModule, MdTooltipModule,
  MdSlideToggleModule, MdInputModule, MdCheckboxModule,
  MdToolbarModule, MdSnackBarModule, MdSidenavModule,
  MdTabsModule, MdSelectModule, MdDatepickerModule, MdNativeDateModule,
  MdSliderModule, MdButtonToggleModule,
  MdProgressBarModule, DateAdapter, MD_DATE_FORMATS, MdDatepickerIntl,
} from '@angular/material';

// TreeModule - Árbol de Técnicas Terapéuticas
import { TreeModule } from 'angular-tree-component';

import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { ChartsModule } from 'ng2-charts/ng2-charts';

import { CovalentHttpModule, IHttpInterceptor, } from '@covalent/http';

import { AuthGuard, LoginService, SaveGuard, } from '../services/';

import { HCIDateAdapter } from './dateFormat/hcidateadapter';
import { HCI_DATE_FORMAT } from './dateFormat/hcidateformat';
import { HCIDateIntl } from './dateFormat/hcidateintl';

import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { PerfilComponent } from './main/perfil/perfil.component';
import { HojaDeConsultaComponent } from './hojadeconsulta/hojadeconsulta.component';
import { HojaDeConsultaDetalleComponent } from './hojadeconsulta/detallehojadeconsulta/detallehojadeconsulta.component';
import { ConsultaComponent } from './consulta/consulta.component';
import { LoginComponent } from './login/login.component';
import { ResumenpacienteComponent } from './consulta/resumenpaciente/resumenpaciente.component';
import { AlergiasComponent } from './consulta/alergias/alergias.component';
import { AlergiasDetalleComponent } from './consulta/alergias/alergiasdetalle/alergiasdetalle.component';
import { DocumentosComponent } from './consulta/documentos/documentos.component';
import { DetalleJustificantesComponent } from './consulta/documentos/detallejustificantes/detallejustificantes.component';
import { DocumentosDetalleComponent } from './consulta/documentos/detalledocumentos/detalledocumentos.component';
import { ConstantesComponent } from './consulta/constantes/constantes.component';
import { ConstantesDetalleComponent } from './consulta/constantes/detalleconstantes/detalleconstantes.component';
import { AltaConstanteComponent } from './consulta/constantes/altaconstante/altaconstante.component';
import { FarmacosComponent } from './consulta/farmacos/farmacos.component';
import { FarmacosDetalleComponent } from './consulta/farmacos/detallefarmacos/detallefarmacos.component';
import { VacunasComponent } from './consulta/vacunas/vacunas.component';
import { VacunasDetalleComponent } from './consulta/vacunas/detallevacunas/detallevacunas.component';
import { HabitosComponent } from './consulta/habitos/habitos.component';
import { HabitosDetalleComponent } from './consulta/habitos/detallehabitos/detallehabitos.component';
import { HojaDeSeguimientoComponent } from './consulta/hojadeseguimiento/hojadeseguimiento.component';
import { MotivosConsultaComponent } from './consulta/hojadeseguimiento/motivosconsulta/motivosconsulta.component';
import { MotivosDetalleComponent } from './consulta/hojadeseguimiento/motivosconsulta/motivosconsultadetalle/motivosdetalle.component';
import { AnamnesisComponent } from './consulta/hojadeseguimiento/anamnesis/anamnesis.component';
import { AnamnesisDetalleComponent } from './consulta/hojadeseguimiento/anamnesis/anamnesisdetalle/anamnesisdetalle.component';
import { ExploracionComponent } from './consulta/hojadeseguimiento/exploracion/exploracion.component';
import { ExploracionDetalleComponent } from './consulta/hojadeseguimiento/exploracion/exploraciondetalle/exploraciondetalle.component';
import { JuicioDiagnosticoComponent } from './consulta/hojadeseguimiento/juiciodiagnostico/juiciodiagnostico.component';
import { JuicioDiagnosticoDetalleComponent } from
'./consulta/hojadeseguimiento/juiciodiagnostico/juiciodiagnosticodetalle/juiciodiagnosticodetalle.component';
import { PlanActuacionComponent } from './consulta/hojadeseguimiento/planactuacion/planactuacion.component';
import { PlanActuacionDetalleComponent } from './consulta/hojadeseguimiento/planactuacion/planactuaciondetalle/planactuaciondetalle.component';
import { CitasComponent } from './consulta/citas/citas.component';
import { CitasDetalleComponent } from './consulta/citas/citasdetalle/citasdetalle.component';
import { CitasAltaComponent } from './consulta/citas/citasalta/citasalta.component';
import { NotasComponent } from './consulta/notas/notas.component';
import { NotasDetalleComponent } from './consulta/notas/notasdetalle/notasdetalle.component';
import { DiagnosticosComponent } from './consulta/diagnosticos/diagnosticos.component';
import { DiagnosticosDetalleComponent } from './consulta/diagnosticos/diagnosticosdetalle/diagnosticosdetalle.component';
import { AltaDiagnosticoComponent } from './consulta/diagnosticos/diagnosticosdetalle/altadiagnostico/altadiagnostico.component';
import { TecnicasDiagnosticasComponent } from './consulta/tecnicasdiagnosticas/tecnicasdiagnosticas.component';
import { TecnicasDiagnosticasDetalleComponent } from
'./consulta/tecnicasdiagnosticas/tecnicasdiagnosticasdetalle/tecnicasdiagnosticasdetalle.component';
import { AltaTecnicaDiagnosticaComponent } from
'./consulta/tecnicasdiagnosticas/tecnicasdiagnosticasdetalle/altatecnicasdiagnosticas/altatecnicasdiagnosticas.component';
import { TecnicasTerapeuticasComponent } from './consulta/tecnicasterapeuticas/tecnicasterapeuticas.component';
import { TecnicasTerapeuticasDetalleComponent } from
'./consulta/tecnicasterapeuticas/tecnicasterapeuticasdetalle/tecnicasterapeuticasdetalle.component';
import { AltaTecnicaTerapeuticaComponent } from
'./consulta/tecnicasterapeuticas/tecnicasterapeuticasdetalle/altatecnicaterapeutica/altatecnicaterapeutica.component';
import { appRoutes, appRoutingProviders } from './app.routes';
import { RequestInterceptor } from '../config/interceptors/request.interceptor';
import { ModAnamnesisComponent } from './consulta/modanamnesis/modanamnesis.component';
// import { NgxChartsModule } from '@swimlane/ngx-charts';

import { CerradosComponent } from './consulta/modanamnesis/cerrados/cerrados.component';
import { CerradosDetalleComponent } from './consulta/modanamnesis/cerrados/cerradosdetalle/cerradosdetalle.component';
import { AltaCerradosComponent } from './consulta/modanamnesis/cerrados/altacerrados/altacerrados.component';

import { PatronesFuncionalesComponent } from './consulta/modanamnesis/patronesfuncionales/patronesfuncionales.component';
import { PatronesDetalleComponent } from './consulta/modanamnesis/patronesfuncionales/patronesdetalle/patronesdetalle.component';
import { PatronesDisponiblesComponent } from './consulta/modanamnesis/patronesfuncionales/patronesdisponibles/patronesdisponibles.component';
import { AltaPatronComponent } from './consulta/modanamnesis/patronesfuncionales/patronesdisponibles/altapatron/altapatron.component';

import { ProgramasFuncionalesComponent } from './consulta/modanamnesis/programasfuncionales/programasfuncionales.component';
import { ProgramasDetalleComponent } from './consulta/modanamnesis/programasfuncionales/programasdetalle/programasdetalle.component';
import { ProgramasDisponiblesComponent } from './consulta/modanamnesis/programasfuncionales/programasdisponibles/programasdisponibles.component';
import { AltaProgramaComponent } from './consulta/modanamnesis/programasfuncionales/programasdisponibles/altaprograma/altaprograma.component';

import { TestComponent } from './consulta/modanamnesis/test/test.component';
import { TestDetalleComponent } from './consulta/modanamnesis/test/testdetalle/testdetalle.component';
import { TestDisponiblesComponent } from './consulta/modanamnesis/test/testdisponibles/testdisponibles.component';
import { AltaTestComponent } from './consulta/modanamnesis/test/testdisponibles/altatest/altatest.component';

import { PreguntasObligatoriasComponent } from './consulta/modanamnesis/preguntasobligatorias/preguntasobligatorias.component';
import { ToggleConfirmarComponent } from './consulta/toggleConfirmar/toggleconfirmar.component';

const httpInterceptorProviders: Type<any>[] = [
  RequestInterceptor,
];

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    PerfilComponent,
    HojaDeConsultaComponent,
    HojaDeConsultaDetalleComponent,
    ConstantesComponent,
    ConstantesDetalleComponent,
    AltaConstanteComponent,
    DocumentosComponent,
    DocumentosDetalleComponent,
    DetalleJustificantesComponent,
    FarmacosComponent,
    FarmacosDetalleComponent,
    VacunasComponent,
    VacunasDetalleComponent,
    HabitosComponent,
    HabitosDetalleComponent,
    ConsultaComponent,
    LoginComponent,
    ResumenpacienteComponent,
    AlergiasComponent,
    AlergiasDetalleComponent,
    HojaDeSeguimientoComponent,
    MotivosConsultaComponent,
    MotivosDetalleComponent,
    AnamnesisComponent,
    ExploracionComponent,
    JuicioDiagnosticoComponent,
    JuicioDiagnosticoDetalleComponent,
    PlanActuacionComponent,
    PlanActuacionDetalleComponent,
    CitasComponent,
    CitasDetalleComponent,
    CitasAltaComponent,
    NotasComponent,
    NotasDetalleComponent,
    DiagnosticosComponent,
    DiagnosticosDetalleComponent,
    AltaDiagnosticoComponent,
    AnamnesisDetalleComponent,
    ExploracionDetalleComponent,
    TecnicasDiagnosticasComponent,
    TecnicasDiagnosticasDetalleComponent,
    AltaTecnicaDiagnosticaComponent,
    TecnicasTerapeuticasComponent,
    TecnicasTerapeuticasDetalleComponent,
    AltaTecnicaTerapeuticaComponent,
    PdfViewerComponent,
    ModAnamnesisComponent,
    CerradosComponent,
    CerradosDetalleComponent,
    PatronesFuncionalesComponent,
    PatronesDetalleComponent,
    PatronesDisponiblesComponent,
    ProgramasFuncionalesComponent,
    ProgramasDetalleComponent,
    ProgramasDisponiblesComponent,
    TestComponent,
    TestDetalleComponent,
    TestDisponiblesComponent,
    AltaTestComponent,
    AltaPatronComponent,
    AltaProgramaComponent,
    AltaCerradosComponent,
    PreguntasObligatoriasComponent,
    ToggleConfirmarComponent,
  ], // directives, components, and pipes owned by this NgModule
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CovalentDataTableModule,
    CovalentMediaModule,
    CovalentLoadingModule,
    CovalentNotificationsModule,
    CovalentLayoutModule,
    CovalentMenuModule,
    CovalentPagingModule,
    CovalentSearchModule,
    CovalentCommonModule,
    CovalentDialogsModule,
    CovalentStepsModule,
    CovalentChipsModule,
    CovalentExpansionPanelModule,
    MdButtonModule,
    MdCardModule,
    MdIconModule,
    MdDatepickerModule,
    MdListModule,
    MdNativeDateModule,
    MdMenuModule,
    MdSliderModule,
    MdTooltipModule,
    MdSlideToggleModule,
    MdInputModule,
    MdCheckboxModule,
    MdToolbarModule,
    MdSnackBarModule,
    MdSidenavModule,
    MdTabsModule,
    MdSelectModule,
    MdButtonToggleModule,
    MdProgressBarModule,
    TreeModule,
    CovalentHttpModule.forRoot({
      interceptors: [{
        interceptor: RequestInterceptor, paths: ['**'],
      }],
    }),
    appRoutes,
    ChartsModule,
  ], // modules needed to run this module
  providers: [
    appRoutingProviders,
    httpInterceptorProviders,
    Title,
    LoginService,
    AuthGuard,
    SaveGuard,
    { provide: DateAdapter, useClass: HCIDateAdapter },
    { provide: MdDatepickerIntl, useClass: HCIDateIntl },
  ], // additional providers needed for this module
  entryComponents: [
    HojaDeConsultaDetalleComponent,
    FarmacosDetalleComponent,
    VacunasDetalleComponent,
    HabitosDetalleComponent,
    DocumentosDetalleComponent,
    DetalleJustificantesComponent,
    ConstantesDetalleComponent,
    AltaTecnicaDiagnosticaComponent,
    AltaTecnicaTerapeuticaComponent,
    AltaDiagnosticoComponent,
    CitasDetalleComponent,
    DiagnosticosDetalleComponent,
    ModAnamnesisComponent,
    PatronesDetalleComponent,
    AltaPatronComponent,
    ProgramasDetalleComponent,
    AltaProgramaComponent,
    TestDetalleComponent,
    AltaTestComponent,
    CerradosDetalleComponent,
    AltaCerradosComponent,
    PreguntasObligatoriasComponent,
    ToggleConfirmarComponent,
  ],
  bootstrap: [AppComponent],
})

export class AppModule {
  constructor(private hciDateAdapter: DateAdapter<Date>) {
    this.hciDateAdapter.setLocale('es-ES');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts